import React from "react";
import {
    Box,
    Typography,
    IconButton,
    Link as MuiLink,
    Divider,
} from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Link as RouterLink } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../translations/translations";

const Footer: React.FC = () => {
    const { language } = useLanguage();
    const t = translations[language].footer;

    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: "#000",
                color: "#fff",
                pt: 6,
                pb: 3,
            }}
        >
            {/* Hauptbereich */}
            <Box
                sx={{
                    maxWidth: "1200px",
                    mx: "auto",
                    px: 3,
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "1fr",
                        md: "2fr 1.5fr 1fr",
                    },
                    gap: 4,
                    alignItems: "flex-start",
                }}
            >
                {/* Links: Brand + Text */}
                <Box>
                    <Typography
                        variant="h6"
                        sx={{
                            fontFamily: "Bangers",
                            letterSpacing: 1,
                            mb: 1,
                        }}
                    >
                        #AI MYTH BUSTERS
                    </Typography>
                    <Typography variant="body2">
                        {t.text}
                    </Typography>
                </Box>

                {/* Mitte: Quick Links */}
                <Box>
                    <Typography
                        variant="subtitle2"
                        sx={{
                            fontFamily: "Bangers",
                            color: "#5B8CB9",
                            letterSpacing: 1,
                            mb: 1.5,
                        }}
                    >
                        {t.quickLinks}
                    </Typography>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                        <MuiLink
                            component={RouterLink}
                            to="/"
                            underline="none"
                            color="inherit"
                            sx={{ "&:hover": { color: "#5B8CB9" } }}
                        >
                            {t.home}
                        </MuiLink>
                        <MuiLink
                            component={RouterLink}
                            to="/quiz"
                            underline="none"
                            color="inherit"
                            sx={{ "&:hover": { color: "#5B8CB9" } }}
                        >
                            {t.myths}
                        </MuiLink>
                        <MuiLink
                            component={RouterLink}
                            to="/sources"
                            underline="none"
                            color="inherit"
                            sx={{ "&:hover": { color: "#5B8CB9" } }}
                        >
                            {t.sources}
                        </MuiLink>
                    </Box>
                </Box>

                {/* Rechts: Social */}
                <Box>
                    <Typography
                        variant="subtitle2"
                        sx={{
                            fontFamily: "Bangers",
                            color: "#5B8CB9",
                            letterSpacing: 1,
                            mb: 1.5,
                        }}
                    >
                        {t.followUs}
                    </Typography>

                    <IconButton
                        aria-label="Instagram"
                        sx={{
                            borderRadius: "12px",
                            border: "1px solid #fff",
                            color: "#fff",
                            "&:hover": {
                                backgroundColor: "rgba(255,255,255,0.08)",
                            },
                        }}
                        // hier deinen Insta-Link eintragen
                        onClick={() =>
                            window.open("https://www.instagram.com", "_blank", "noreferrer")
                        }
                    >
                        <InstagramIcon />
                    </IconButton>
                </Box>
            </Box>

            {/* Linie + Copyright */}
            <Box sx={{ maxWidth: "1200px", mx: "auto", px: 3, mt: 4 }}>
                <Divider sx={{ borderColor: "rgba(255,255,255,0.2)" }} />
                <Typography
                    variant="body2"
                    sx={{ textAlign: "center", mt: 2, opacity: 0.8 }}
                >
                    {t.bottomText}
                </Typography>
            </Box>
        </Box>
    );
};

export default Footer;
